import React from "react";
import assetPath from "~/utils/assetPath";
import LayoutComponent from "~/components/LayoutComponent";
import Puzzles from "./Puzzles";

function action(context, params) {
  return {
    chunks: ["puzzles"],
    title: "Play Free Online Jigsaw Puzzle Games",
    description:
      "Jigsaw Puzzle is a classic jigsaw game. Choose from over 500.000 stunning pictures. Choose a difficulty between 11 and 625 pieces. Play online or download for Windows™ or Mac™.",
    image: assetPath("frontpage_desktop", "jpg"),
    pathname: "/",
    component: (
      <LayoutComponent>
        <Puzzles id={context.params.id} />
      </LayoutComponent>
    )
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/puzzles/index.js